export const GutterProperty = {
  Size: 'size',
  Position: 'position',
};

export const FlexDirection = {
  Row: 'row',
  Column: 'column',
};
